import { FloatingFilterButton } from '~shared/ui/floating-filter-button';

import {
  BusinessSelect,
  StatusSelect,
  StoreSelect,
} from './applications-filter-fields';

type Props = {
  hideMerchantFilter: boolean;
  activeCount: number;
  onApply: () => void;
  onClear: () => void;
};

export function ApplicationsFiltersMobile({
  hideMerchantFilter,
  activeCount,
  onApply,
  onClear,
}: Props) {
  return (
    <FloatingFilterButton
      activeCount={activeCount}
      onApply={onApply}
      onClear={onClear}
    >
      <StatusSelect />
      {!hideMerchantFilter && <BusinessSelect />}
      <StoreSelect />
    </FloatingFilterButton>
  );
}
